import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pro-archive',
  templateUrl: './pro-archive.component.html',
  styleUrls: ['./pro-archive.component.scss']
})
export class ProArchiveComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
